<template>
  <div
    class="
      layout/width:100%
      layout/flex
      $typography/size:medium
    "
    >
    <div
      v-if="showArrows"
      class="
        layout/align:center
        layout/flex
        layout/justify:start
        layout/margin:right:cap
        layout/relative
      "
      >
      <button
        aria-label="Previous day"
        class="
          link/focus
        "
        @click="prevDay"
        >
        <div
          aria-hidden="true"
          class="
            $typography/size:large
            typography/icon:180deg
            "
          >
          <Icon
            icon-name="icon__caret--16--stroke.svg"
            class-name="color/black"
          />
        </div>
      </button>
    </div>
    <div
      class="
        layout/width:100%
        link/focus
      "
      >
      <div
        class="
          layout/height:baseline:3
          layout/border:3pt
          layout/relative
          layout/width:100%
        "
        >
        <div
          class="
            layout/align:center
            layout/flex
            layout/height:100%
            layout/padding:cap
          "
          >
          <label
            v-if="browserHasDatePicker"
            class="layout/width:100%"
            :for="id"
            >
            <p
              class="
                layout/margin:clear
                layout/width:100%
                typography
              "
              v-html="formattedDate"
            />
          </label>
          <input
            v-if="browserHasDatePicker"
            :id="id"
            aria-label="Select a date"
            :name="name"
            :value="dateRaw.toJSON().substring(0,10)"
            class="
              layout/absolute
              layout/bottom:0%
              layout/left:0%
              layout/margin:clear
              layout/opacity:0%
              layout/right:0%
              layout/top:0%
              layout/width:100%
              typography
            "
            type="date"
            @change="browserChange"
          >
          <duet-date-picker
            v-else
            ref="duetDatePicker"
            aria-label="Select a date"
            :identifier="id"
            :name="name"
            :localization.prop="localization"
            :date-adapter.prop="dateAdapter"
            :value.prop="dateRaw.toJSON().substring(0,10)"
            class="
              layout/margin:clear
              layout/width:100%
              typography
            "
            @duetChange="duetChange"
            @duetFocus="duetFocus"
          />
          <div
            aria-hidden="true"
            class="
              layout/absolute
              layout/align:center
              layout/flex
              layout/height:100%
              layout/margin:right:cap
              layout/right:0%
              layout/top:0%
              link/disable
            "
            >
            <Icon
              icon-name="icon__calendar--16.svg"
              class-name="color/black"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showArrows"
      class="
        layout/align:center
        layout/flex
        layout/justify:end
        layout/margin:left:cap
        layout/relative
      "
      >
      <button
        aria-label="Next day"
        class="
          link/focus
        "
        @click="nextDay"
        >
        <div
          aria-hidden="true"
          class="
            $typography/size:large
            typography/icon
            "
          >
          <Icon
            icon-name="icon__caret--16--stroke.svg"
            class-name="color/black"
          />
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import Icon from "../icons/icon";
import momaDate, { dayShort, monthShort, monthLong } from '../../utils/date';

export default {
  components: {
    Icon
  },
  model: {
    prop: "dateRaw",
    event: "change",
  },
  props: {
    name: { type: String, default: "" },
    id: { type: String, default: "" },
    showArrows: {type: Boolean, default: true},
    dateRaw: {type: Date, required: true},
  },
  data: function() {
    return {
      dateAdapter: {
        parse: (str) => {
          return new Date(`${str}T00:00:00-05:00`);
        },
        format: momaDate,
      },
      localization: {
        buttonLabel: 'Select a date',
        placeholder: 'DD/MM/YYYY',
        selectedDateMessage: 'Selected date is',
        prevMonthLabel: 'Previous month',
        nextMonthLabel: 'Next month',
        monthSelectLabel: 'Month',
        yearSelectLabel: 'Year',
        closeLabel: 'Close window',
        keyboardInstruction: 'You can use arrow keys to navigate dates',
        calendarHeading: 'Select a date',
        dayNames: dayShort,
        monthNames: monthLong,
        monthNamesShort: monthShort,
      },
    };
  },
  computed: {
    browserHasDatePicker: function() {
      const input = document.createElement('input');
      input.setAttribute('type', 'date');
      input.value = '1995-07-10';
      return !!input.valueAsDate;
    },
    formattedDate: function() {
      return momaDate(this.dateRaw);
    }
  },
  methods: {
    browserChange(e) {
      this.$emit("change", new Date(`${e.target.value}T00:00:00-05:00`));
    },
    duetChange(e) {
      this.$emit("change", e.detail.valueAsDate);
    },
    duetFocus() {
      this.$refs['duetDatePicker'].show();
    },
    prevDay(e) {
      e.preventDefault();
      const prev = new Date(this.dateRaw.getTime());
      prev.setDate(prev.getDate() - 1);
      this.$emit("change", prev);
    },
    nextDay(e) {
      e.preventDefault();
      const next = new Date(this.dateRaw.getTime());
      next.setDate(next.getDate() + 1);
      this.$emit("change", next);
    },
  },
};
</script>

<style>
  @import '~@duetds/date-picker/dist/duet/themes/default.css';

  :root {
    --duet-color-primary: var(--color--session);
    --duet-color-text: var(--color--black);
    --duet-color-text-active: var(--color--white);
    --duet-color-button: var(--color--gray--eee);
    --duet-color-surface: var(--color--white);
    --duet-color-overlay: rgba(0, 0, 0, 0.8);

    --duet-font: var(--language-font-face);
    --duet-font-normal: var(--typography--weight);
    --duet-font-bold: var(--typography--weight);

    --duet-radius: 0px;
  }

  input.duet-date__input {
    border: none;
    padding: unset;
    background: inherit;
  }

  button.duet-date__toggle {
    opacity: 0;
    width: 100%;
  }

  div.duet-date__dialog {
    min-width: unset;
  }

  button.duet-date__day,
  th.duet-date__table-header {
    font-size: unset;
    text-transform: unset;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  input[type="date"]::-webkit-datetime-edit-month-field {
    visibility: hidden;
  }

  input[type="date"]::-webkit-datetime-edit-day-field {
    visibility: hidden;
   }
  input[type="date"]::-webkit-datetime-edit-year-field {
    visibility: hidden;
  }

</style>
